var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.108 13.094 18.605 28.69h-4.217l-3.08-12.366a2.262 2.262 0 0 0-.91-1.383 17.004 17.004 0 0 0-3.88-1.274l.118-.463h6.84c.422.016.836.168 1.165.438.329.27.565.641.666 1.063l1.712 9.008 4.108-10.628h3.99l-.009.009zM41.531 23.72c0-4.158-5.593-4.394-5.593-6.241 0-.582.574-1.156 1.713-1.274a7.51 7.51 0 0 1 3.88.692l.683-3.349c-1.198-.464-2.48-.7-3.762-.691-3.99 0-6.731 2.193-6.731 5.195 0 2.311 2.05 3.467 3.534 4.277 1.485.81 2.168 1.274 2.168 1.847 0 1.038-1.257 1.502-2.396 1.502a10.04 10.04 0 0 1-4.107-.928l-.802 3.348a11.63 11.63 0 0 0 4.445.81c4.218.118 6.96-2.083 6.96-5.196l.008.008zm10.492 5.087h3.652L52.37 13.212h-3.424a1.984 1.984 0 0 0-1.012.337c-.304.203-.54.49-.7.819l-5.93 14.558h4.217l.801-2.311h5.137l.574 2.193h-.009zm-4.445-5.55 2.168-5.778 1.139 5.778h-3.307zM30.7 13.094 27.394 28.69h-3.99l3.307-15.596h3.99z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7d427a63bee585874afe997aa8344ab0.svg";
export { ForwardRef as ReactComponent };